import { createContext, useContext, useEffect, useState } from "react";
import api, { API } from "@/lib/api";

const Ctx = createContext({});

export const SiteImagesProvider = ({ children }) => {
  const [images, setImages] = useState({});
  useEffect(() => {
    api.get("/content/images").then(({ data }) => setImages(data)).catch(() => {});
  }, []);
  return <Ctx.Provider value={images}>{children}</Ctx.Provider>;
};

export const useSiteImages = () => {
  const images = useContext(Ctx);
  return (key, fallback) => (images[key] ? `${API}/public/files/${images[key]}` : fallback);
};
